export default "/assets/images/CC-product.e9eb9216619025ab.png";